import React from 'react';
export default function MonthContainer({ month, children }) {
	return (
		<div className="month-container__inner grid-item">
			<h2 className="h3">{month}</h2>
			{children}
		</div>
	)
};
